import { render, staticRenderFns } from "./error403.vue?vue&type=template&id=98b3fde6&scoped=true"
import script from "./error403.vue?vue&type=script&lang=js"
export * from "./error403.vue?vue&type=script&lang=js"
import style0 from "./error403.vue?vue&type=style&index=0&id=98b3fde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b3fde6",
  null
  
)

export default component.exports